// extracted by mini-css-extract-plugin
export default {"dot":"KvK7FlG4dqpPt8z_It9z","icon":"kgdpCkwYmSosAsq08PSY","s":"d1Q006ESvEtnbsIxVPLr","m":"W19S9nZjEww_11nxapy_"};